import React from 'react';

const StatusTag = ({ label, isActive }) => (
  <div style={{
    fontSize: '0.65rem',
    padding: '2px 8px',
    borderRadius: '12px',
    backgroundColor: isActive ? '#e3f2fd' : '#f5f5f5',
    color: isActive ? '#1976d2' : '#9e9e9e',
    border: `1px solid ${isActive ? '#2196f3' : '#e0e0e0'}`,
    fontWeight: isActive ? 'bold' : 'normal',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    opacity: isActive ? 1 : 0.6
  }}>
    {label}: <span style={{ color: isActive ? '#0d47a1' : '#757575' }}>{isActive ? 'SI' : 'NO'}</span>
  </div>
);

const isValidValue = (val) => {
  if (val === null || val === undefined || val === '') return false;
  const s = val.toString().trim().toUpperCase();
  return s !== 'N/A' && s !== 'NONE' && s !== 'NULL';
};

const JsonDataRenderer = ({ jsonData, fields, label }) => {
  if (!jsonData || !fields || fields.length === 0) return null;

  const boolFields = fields.filter(f => f.type === 'bool');
  const textFields = fields.filter(f => !f.type && !f.key.endsWith('_'));

  if (textFields.length === 0 && boolFields.length === 0) return null;

  return (
    <>
      {textFields.map(f => {
        const val = jsonData[f.key];
        if (!isValidValue(val)) return null;
        return (
          <div key={f.key} className="d-flex justify-content-between mb-1 small">
            <span className="text-muted">{f.label}:</span>
            <span className="fw-bold">{val}</span>
          </div>
        );
      })}
      {boolFields.length > 0 && (
        <div className="d-flex flex-wrap gap-1 mt-2">
          {boolFields.map(f => {
            const val = jsonData[f.key];
            const isActive = val === 1 || val === '1' || val === true;
            return (
              <StatusTag key={f.label} label={f.label} isActive={isActive} />
            );
          })}
        </div>
      )}
    </>
  );
};

export default React.memo(JsonDataRenderer);
